import { ChainId, SmartRouter } from '@babydogeswap/sdk'

// This sets the priority of when a router is used
// After BabyDoge router should be in order of highest liquidity
export const PRIORITY_SMART_ROUTERS = {
  [ChainId.MAINNET]: [
    SmartRouter.BABYDOGE,
    SmartRouter.PANCAKE,
    SmartRouter.APE,
    SmartRouter.BISWAP,
    SmartRouter.SUSHISWAP,
  ],
  [ChainId.TESTNET]: [SmartRouter.BABYDOGE, SmartRouter.PANCAKE, SmartRouter.SUSHISWAP],
}
